export { default } from "./FTButton";
